import React from 'react';
import { useMaps } from '../../contexts/MapsContext';
import './StatsCards.css';

const StatsCards = () => {
  const { stats, loading } = useMaps();

  if (loading) {
    return (
      <div className="stats-section">
        <h3 className="stats-title">Loading Statistics...</h3>
        <div className="stats-loading">
          <div className="stats-spinner"></div>
        </div>
      </div>
    );
  }

  return (
    <div className="stats-section">
      <h3 className="stats-title">Your Pop-Map Statistics</h3>
      <div className="stats-grid">
        <div className="stat-card">
          <div className="stat-icon"></div>
          <div className="stat-number">{stats.totalMaps}</div>
          <div className="stat-label">Maps Created</div>
        </div>
        <div className="stat-card">
          <div className="stat-icon"></div>
          <div className="stat-number">{stats.activeMaps}</div>
          <div className="stat-label">Active Maps</div>
        </div>
        <div className="stat-card">
          <div className="stat-icon"></div>
          <div className="stat-number">{stats.totalVisits}</div>
          <div className="stat-label">Total Visits</div>
        </div>
        <div className="stat-card">
          <div className="stat-icon"></div>
          <div className="stat-number">{stats.totalMarkers}</div>
          <div className="stat-label">Total Markers</div>
        </div>
      </div>
    </div>
  );
};

export default StatsCards;
